import { render, staticRenderFns } from "./publish-product-form-radio.vue?vue&type=template&id=4055f586&scoped=true&"
import script from "./publish-product-form-radio.vue?vue&type=script&lang=js&"
export * from "./publish-product-form-radio.vue?vue&type=script&lang=js&"
import style0 from "./publish-product-form-radio.vue?vue&type=style&index=0&id=4055f586&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4055f586",
  null
  
)

export default component.exports